<span class="chip chip-success" *ngIf="state == stateUsageCoupon.ASSOCIATE">
  {{'state.associate' | translate}}
</span>
<span class="chip chip-warning" *ngIf="state == stateUsageCoupon.USED">
  {{'state.used' | translate}}
</span>